import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {AppState} from '../reducers';
import {selectLoginState} from '../auth/login/selectors/login.selectors';
import {State} from '../auth/login/reducers/login.reducer';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  private loginState$: Observable<State>;
  private isAuthenticated: boolean;

  constructor(private store: Store<AppState>, private router: Router) {
    this.loginState$ = this.store.pipe(select(selectLoginState));
  }

  // canActivate(route: ActivatedRouteSnapshot,
  //             state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   if (state.url === '/car-market' || state.url === '/cars-coll') {
  //     return true;
  //   }
  //
  //   sessionStorage.setItem('returnUrl', state.url);
  //
  //   return this.loginState$.pipe(map((loginState: State) => {
  //     // debugger;
  //     if (loginState.isLogin && loginState.userData.cpms == 1 && loginState.userData.cpmCount < 0) {
  //       this.router.navigate(['/subscribe']);
  //       return false;
  //     } else if (loginState.isLogin && loginState.userData.cpms == 1 && loginState.userData.cpmCount > 0){
  //       return true;
  //     } else if (loginState.isLogin && loginState.userData.cpms == 1 && loginState.userData.cpmCount == 0){
  //       this.router.navigate(['/subscribe']);
  //       return false;
  //     } else if (loginState.isLogin && loginState.userData.cpms == 0){
  //       return true;
  //     } else if (!loginState.isLogin) {
  //       this.router.navigate(['/auth/login']);
  //       return false;
  //     }
  //
  //
  //     this.router.navigate(['/auth/login']);
  //     return false;
  //   }));
  // }
  //
  //
  // canActivateChild(
  //   childRoute: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return this.canActivate(childRoute, state);
  // }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const userId = sessionStorage.getItem('user-id');

    if (userId) {
      // User is logged in, return true
      return true;
    }

    if (state.url === '/car-market' || state.url === '/cars-coll') {
      return true;
    }

    sessionStorage.setItem('returnUrl', state.url);

    // Redirect to login page
    this.router.navigate(['/auth/login']);
    return false;

  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

}
